import { SVGProps } from 'react';

const SvgMailboxFlagUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M376 224c-13.3 0-24-10.7-24-24V56c0-13.3 10.7-24 24-24h64c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-40v88c0 13.3-10.7 24-24 24zM144 112c-53 0-96 43-96 96v176c0 8.8 7.2 16 16 16h176V208c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96v192h224c8.8 0 16-7.2 16-16V208c0-34.9-18.7-65.5-46.6-82.3 9.1-9.9 14.6-23.2 14.6-37.7v-9c47.4 23.6 80 72.5 80 129v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64h176v48h-68.7zM104 192h80c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
  </svg>
);
export default SvgMailboxFlagUp;
